import React from 'react';
import { FaMapMarked } from '@react-icons/all-files/fa/FaMapMarked';
import { FaPhoneAlt } from '@react-icons/all-files/fa/FaPhoneAlt';
import { FaLink } from '@react-icons/all-files/fa/FaLink';
import styles from './styles.module.css';
import { breakLink } from '../../utils';
export const PopoverContent = _ref => {
  let {
    result
  } = _ref;
  let linkLabel = null;
  let url = null;
  if (result.fields.__kind === 'cemetery' && result.data.groundsMap) {
    // const parts = breakLink(result.data.groundsMap);
    // domain = parts.domain;
    // url = parts.url;
    linkLabel = 'Grounds Map';
    url = result.data.groundsMap;
  } else if (result.data.website || result.fields.__kind === 'parish' || result.fields.__kind === 'school') {
    const parts = breakLink(result.data.website);
    linkLabel = parts.domain;
    url = parts.url;
  }
  let phoneNumber = null;
  let phoneNumberLabel = null;
  let phoneNumberDigits = null;
  let phoneNumberAlt = null;
  let phoneNumberAltLabel = null;
  let phoneNumberAltDigits = null;
  if (result.data.phone) {
    phoneNumber = result.data.phone;
    phoneNumberDigits = phoneNumber.replace(/[^\d]/g, '');
  }
  ;
  if (result.fields.__kind === 'cemetery' && result.data.phoneSpanish) {
    phoneNumberAlt = result.data.phoneSpanish;
    phoneNumberAltDigits = phoneNumberAlt.replace(/[^\d]/g, '');
    if (phoneNumberDigits === phoneNumberAltDigits) {
      phoneNumberLabel = /*#__PURE__*/React.createElement("div", {
        className: styles.altText
      }, "[ English + Espa\xF1ol ]");
    } else {
      phoneNumberLabel = /*#__PURE__*/React.createElement("div", {
        className: styles.altText
      }, "[ English ]");
      phoneNumberAltLabel = /*#__PURE__*/React.createElement("div", {
        className: styles.altText
      }, "[ Espa\xF1ol ]");
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.PopoverContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.address
  }, result.fields.displayAddress[0], /*#__PURE__*/React.createElement("br", null), result.fields.displayAddress[1], /*#__PURE__*/React.createElement("br", null), result.fields.displayAddress.length == 3 && result.fields.displayAddress[1]), /*#__PURE__*/React.createElement("div", {
    className: styles.links
  }, url && /*#__PURE__*/React.createElement("a", {
    className: styles.link,
    href: url,
    target: "_blank"
  }, result.fields.__kind === 'cemetery' ? /*#__PURE__*/React.createElement(FaMapMarked, {
    size: 16
  }) : /*#__PURE__*/React.createElement(FaLink, {
    size: 16
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, linkLabel)), phoneNumber && /*#__PURE__*/React.createElement("a", {
    className: styles.link,
    href: `tel:${phoneNumber.replace(/[^\d]/g, '')}`
  }, /*#__PURE__*/React.createElement(FaPhoneAlt, {
    size: 16
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, phoneNumber), phoneNumberLabel), phoneNumberAlt && phoneNumberAltLabel && /*#__PURE__*/React.createElement("a", {
    className: styles.link,
    href: `tel:${phoneNumberAlt.replace(/[^\d]/g, '')}`
  }, /*#__PURE__*/React.createElement(FaPhoneAlt, {
    size: 16
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, phoneNumberAlt), phoneNumberAltLabel)));
};
export default PopoverContent;